<script setup lang="ts">
/**
 * Modale Quêtes : ouvre la vue Quests en overlay (overlays.store) au lieu d'une
 * navigation pleine page. La route /quests reste un deep-link.
 */
import { computed } from 'vue';
import { useOverlaysStore } from '@/stores/overlays.store';
import QuestsView from '@/views/game/QuestsView.vue';

const overlays = useOverlaysStore();
const open = computed({
  get: () => overlays.questsOpen,
  set: (v: boolean) => { overlays.questsOpen = v; },
});
</script>

<template>
  <el-dialog
    v-model="open"
    title="🚩 Quêtes"
    width="min(94vw, 1100px)"
    append-to-body
    destroy-on-close
    align-center
    class="overlay-dialog"
  >
    <QuestsView v-if="open" />
  </el-dialog>
</template>

<style scoped lang="scss">
.overlay-dialog :deep(.el-dialog__body) {
  max-height: 80vh;
  overflow-y: auto;
  padding-top: 0;
}
</style>
